import type { ComponentProps } from 'react';
import type { Badge } from '@/components/Badge';
import type { ApiResponseBody } from '@/lib/api/api-type-helper';

// 契約ステータスの型定義
export type ContractStatus = ApiResponseBody<'/v2/contract-ledger/contracts/{contractId}/profile-header', 'get'>['contract']['contractStatus'] | ApiResponseBody<'/v2/contract-ledger/employment-contracts', 'get'>['items'][0]['contractStatus'];

// Badge variant の型定義
export type BadgeVariant = ComponentProps<typeof Badge>['variant'];

// ステータスに基づいてBadgeのvariantを返すユーティリティ関数
export const getContractStatusBadgeVariant = (status: ContractStatus): BadgeVariant => {
  switch (status) {
    case 'EXECUTED':
      return 'mutedSuccess';
    case 'DRAFT':
    case 'WAITING':
      return 'neutralMuted';
    case 'TERMINATED':
    case 'CANCELLED':
      return 'mutedWarning';
    default:
      return 'neutralMuted';
  }
};

// ステータスの分類を返すユーティリティ関数
export const getContractStatusCategory = (status: ContractStatus): 'active' | 'pending' | 'inactive' => {
  switch (status) {
    case 'EXECUTED':
      return 'active';
    case 'DRAFT':
    case 'WAITING':
      return 'pending';
    case 'TERMINATED':
    case 'CANCELLED':
      return 'inactive';
    default:
      return 'pending';
  }
};